import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageLoaderService {
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this._isLoading$.asObservable();

  constructor() { }

  get isLoading() {
    return this._isLoading$.getValue();
  }

  set(value: boolean) {
    this._isLoading$.next(value);
  }

  toggle() {
    this._isLoading$.next(!this.isLoading);
  }

  start() {
    this._isLoading$.next(true);
  }

  stop() {
    this._isLoading$.next(false);
  }
}
